<template>
  <div class="regroupements">
    <p class="title">
      {{ this.title }}
    </p>
    <div class="flex-wrap-fJstart-fAcenter">
      <RegroupementSelect
        v-for="attribut of attributs"
        :key="attribut.nature + attribut.propriete"
        :selected="attribut.selected"
        :options="attribut.options"
        :propriete="attribut.propriete"
        :designation="attribut.designation"
        :suffixe="attribut.suffixe"
        :nature="attribut.nature"
        @change="onAttributChange"
      />
    </div>
  </div>
</template>
<script>
import RegroupementSelect from './RegroupementSelect.vue'
export default {
  components: { RegroupementSelect },
  props: {
    title: {
      type: String,
      default: ''
    },
    currentArticle: {
      type: String,
      default: ''
    },
    regroupement: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      selectHashtable: {}
    }
  },
  computed: {
    attributs() {
      const attributs = this.regroupement.attributs.map(
        attribut => {
          const { nature, propriete, suffixe } = attribut
          let selected = null
          const options = this.regroupement.articles.reduce((options, article) => {
            const articleValue = this.getArticleValue(nature, propriete, article)
            const selectedCache = this.getSelectedValue(nature, propriete, article.HIDDEN_CODE_ARTICLE, this.currentArticle, articleValue)
            selected = selectedCache !== null ? selectedCache : selected
            if (articleValue !== null && articleValue !== 0) {
              options[articleValue] = options.hasOwnProperty(articleValue) ? options[articleValue] : { articles: [] }
              options[articleValue].articles.push(article.HIDDEN_CODE_ARTICLE)
            }
            return options
          }, {})
          const designation = attribut.designation
          return {
            propriete,
            nature,
            designation,
            options,
            selected,
            suffixe
          }
        }
      )
      const cacheAttributs = [...attributs]
      attributs.map(attribut => {
        cacheAttributs.shift()
        let { options } = attribut
        options = Object.entries(options).reduce((acc, [valeur, { articles }]) => {
          const option = options[valeur]
          option.available = true
          let available = false
          if (!option.selected) {
            cacheAttributs.forEach(filterAttribut => {
              const subOptions = filterAttribut.options
              return Object.entries(subOptions).forEach(([subValeur, subArticles]) => {
                available = Object.values(subArticles.articles).filter(subArticle => {
                  articles.includes(subArticle)
                })
              })
            })
          }
          acc[valeur] = option
          return acc
        }, {})
        return {
          ...attribut,
          options
        }
      })
      return attributs
    }
  },
  methods: {
    getArticleValue(nature, propriete, article) {
      return (nature === 'OPT' || nature === 'ERP') ? article.OPTIONS_REGPT[propriete] : null
    },
    getSelectedValue(nature, propriete, codeArticle, codeCurrentArticle, articleValue) {
      const hashTargetProperty = `${nature}.${propriete}`
      if (this.selectHashtable.hasOwnProperty(hashTargetProperty)) {
        return this.selectHashtable[hashTargetProperty]
      }
      return (codeCurrentArticle === codeArticle && articleValue !== null) ? articleValue : null
    },
    fetchArticleFromAttributs() {
      const { attributs } = this
      const matchingArticlesFromAttribut = attributIndex => {
        const attribut = attributs[attributIndex]
        return attribut.options[attribut.selected].articles
      }
      let intersection = new Set(matchingArticlesFromAttribut(0))
      for (let i = 1; i < attributs.length; i++) {
        intersection = new Set(
          [...intersection].filter(x => new Set(matchingArticlesFromAttribut(i)).has(x))
        )
      }
      return intersection
    },
    fetchArticleFromSelectedAttribut(propriete, nature) {
      const { attributs } = this
      for (let i = 0; i < attributs.length; i++) {
        const attribut = attributs[i]
        if (attribut.nature === nature && attribut.propriete === propriete) {
          return new Set(attribut.options[attribut.selected].articles)
        }
      }
    },
    onAttributChange({ selected, propriete, nature }) {
      Vue.set(this.selectHashtable, `${nature}.${propriete}`, selected)
      // On racourcis a un article vu les specs
      let  selectedArticleCode = this.fetchArticleFromAttributs().values().next().value
      if (selectedArticleCode === undefined) {
        selectedArticleCode = this.fetchArticleFromSelectedAttribut(propriete, nature).values().next().value
      }
      const selectedArticle = this.regroupement.articles.find(article => {
        return article.HIDDEN_CODE_ARTICLE === selectedArticleCode
      })
      window.location.href = selectedArticle.LIEN_FICHE
    }
  }
}
</script>
